/* eslint-disable import/no-cycle */
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  ElementPartTypeEnum,
  TemplateStructureEnum,
} from '@/types';
import getWysiwygEditorFieldConfig from '@/components/template-builder/config/fields/wysiwyg-editor-config';
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import {
  setContent,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getContent,
  getCssPropertyByName,
} from '@/components/template-builder/getters';
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const emailWidgetTextConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.text',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.wysiwygEditor',
            selector: '{SELECTOR}.spm_widget_text > tbody > tr > th .spm_rich_editor, {SELECTOR}.spm_widget_display_text > div.spm_rich_editor',
            properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
            ...getWysiwygEditorFieldConfig('<div>Votre contenu ici</div>', variables.allVariables),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR}',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
            getWidgetCommonStylesGroup(),
          ],
        },
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
    ],
  },
};

export default emailWidgetTextConfig;
